import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { LeadershipRoutingModule } from './leadership-routing.module';
import { LeadershipListComponent } from './leadership-list/leadership-list.component';
import { LeadershipCreateComponent } from './leadership-create/leadership-create.component';

@NgModule({
  declarations: [LeadershipListComponent, LeadershipCreateComponent],
  imports: [
    CommonModule,
    LeadershipRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class LeadershipModule { }
